/**
 * @file FX de tir (cosmetiques, boutique) : achat en gemmes / Rubis, equipement (ou retrait), style actif lu par le rendu.
 */
import { fail, okVoid } from '@shared/types';
import type { Result } from '@shared/types';
import type { ShotFxStyle } from '@config/types';
import type { SimContext } from '../Context';

export class ShotFxService {
  constructor(private readonly ctx: SimContext) {}

  owns(id: string): boolean {
    return this.ctx.data.shotFx.owned.includes(id);
  }

  /** Style de l'FX de tir equipe (null = aucun). */
  activeStyle(): ShotFxStyle | null {
    const id = this.ctx.data.shotFx.equipped;
    return id === null ? null : this.ctx.index.shotFx(id).style;
  }

  buy(id: string): Result {
    const ctx = this.ctx;
    const fx = ctx.config.shotFx.find((f) => f.id === id);
    if (!fx) return fail('unknownId');
    if (this.owns(id)) return fail('alreadyOwned');
    return ctx.tx.purchase(fx.cost, `shotfx:${id}`, () => {
      ctx.data.shotFx.owned.push(id);
      ctx.bus.emit('ShotFxBought', { id });
      return okVoid;
    });
  }

  /** Equipe un FX possede (null = retirer). */
  equip(id: string | null): Result {
    const ctx = this.ctx;
    if (id !== null) {
      if (!ctx.config.shotFx.some((f) => f.id === id)) return fail('unknownId');
      if (!this.owns(id)) return fail('notOwned');
    }
    ctx.data.shotFx.equipped = id;
    ctx.bus.emit('ShotFxEquipped', { id });
    return okVoid;
  }
}
